import {PlayerReduxState} from "../types";
import getMaxLevel from "./getMaxLevel";

export default function isResultStage(state: PlayerReduxState): boolean {
  return state.level === getMaxLevel(state) + 1 || state.interrupted;
}
